export default "__VITE_ASSET__DTyR$Zy$__"